
export function screenType(width: number): string {
  if (width < 769) { return 'mobile'; }
  if (width < 1024) { return 'tablet'; }
  if (width < 1216) { return 'desktop'; }
  if (width < 1408) { return 'widescreen'; }
  return 'fullhd';
}
